export const actions = {
  FECHAS_SENALADAS_URL_LOAD_REQUESTED: 'FECHAS_SENALADAS_URL_LOAD_REQUESTED',
  FECHAS_SENALADAS_URL_LOAD_SUCCEEDED: 'FECHAS_SENALADAS_URL_LOAD_SUCCEEDED',
  FECHAS_SENALADAS_URL_LOAD_FILED: 'FECHAS_SENALADAS_URL_LOAD_FILED',

  FECHAS_SENALADAS_URL_INSERT_REQUESTED: 'FECHAS_SENALADAS_URL_INSERT_REQUESTED',
  FECHAS_SENALADAS_URL_INSERT_SUCCEEDED: 'FECHAS_SENALADAS_URL_INSERT_SUCCEEDED',
  FECHAS_SENALADAS_URL_INSERT_FILED: 'FECHAS_SENALADAS_URL_INSERT_FILED',

  FECHAS_SENALADAS_URL_UPDATE_REQUESTED: 'FECHAS_SENALADAS_URL_UPDATE_REQUESTED',
  FECHAS_SENALADAS_URL_UPDATE_SUCCEEDED: 'FECHAS_SENALADAS_URL_UPDATE_SUCCEEDED',
  FECHAS_SENALADAS_URL_UPDATE_FILED: 'FECHAS_SENALADAS_URL_UPDATE_FILED',

  FECHA_SENALADA_URL_DELETE_REQUESTED: 'FECHA_SENALADA_URL_DELETE_REQUESTED',
  FECHA_SENALADA_URL_DELETE_SUCCEEDED: 'FECHA_SENALADA_URL_DELETE_SUCCEEDED',
  FECHA_SENALADA_URL_DELETE_FILED: 'FECHA_SENALADA_URL_DELETE_FILED',

  FECHA_SENALADA_URL_GET_SORT_IMAGES_REQUESTED: 'FECHA_SENALADA_URL_GET_SORT_IMAGES_REQUESTED',
  FECHA_SENALADA_URL_GET_SORT_IMAGES_SUCCEEDED: 'FECHA_SENALADA_URL_GET_SORT_IMAGES_SUCCEEDED',
  FECHA_SENALADA_URL_GET_SORT_IMAGES_FILED: 'FECHA_SENALADA_URL_GET_SORT_IMAGES_FILED',

  FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_REQUESTED:
    'FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_REQUESTED',
  FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_SUCCEEDED:
    'FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_SUCCEEDED',
  FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_FILED: 'FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_FILED',
}

// idiomaId es opcional: si se pasa, la API sólo devuelve las urls marcadas como
// visibles (Mostrar) en ese idioma.
export const getFechasSenaladasUrlAction = (dispatch, fechaId, idiomaId = null) => {
  dispatch({
    type: actions.FECHAS_SENALADAS_URL_LOAD_REQUESTED,
    payload: { id: fechaId, idiomaId },
  })
}

export const getFechasSenaladasUrlSortImagesAction = (dispatch, fechaId, idiomaId = null) => {
  dispatch({
    type: actions.FECHA_SENALADA_URL_GET_SORT_IMAGES_REQUESTED,
    payload: { id: fechaId, idiomaId },
  })
}

export const onSubmitFechaSenaladaUrlAction = (dispatch, fechaSenaladaUrlForm) => {
  dispatch({
    type: actions.FECHAS_SENALADAS_URL_INSERT_REQUESTED,
    payload: fechaSenaladaUrlForm,
  })
}

export const onSubmitFechaSenaladaUrlUpdateAction = (dispatch, fechaSenaladaUrlForm) => {
  dispatch({
    type: actions.FECHAS_SENALADAS_URL_UPDATE_REQUESTED,
    payload: fechaSenaladaUrlForm,
  })
}

export const onSubmitFechaSenaladaUrlSortImagesUpdateAction = (dispatch, fechaSenaladaUrlForm) => {
  dispatch({
    type: actions.FECHAS_SENALADAS_URL_SORT_IMAGES_UPDATE_REQUESTED,
    payload: fechaSenaladaUrlForm,
  })
}

export const deleteFechaSenaladaUrlAction = (dispatch, id) => {
  dispatch({
    type: actions.FECHA_SENALADA_URL_DELETE_REQUESTED,
    payload: id,
  })
}
